import PropTypes from 'prop-types';
import React from 'react';
import ButtonV2 from 'components/ButtonV2';
import {
  Pagination,
  PageEllipsis,
} from 'pages/track/Customers/CustomerDetail/StyledComponents';

const ARROW_PATHS = {
  prev: 'M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z',
  next: 'M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z',
};

const ArrowIcon = ({ direction }) => (
  <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
    <path fillRule="evenodd" d={ARROW_PATHS[direction]} />
  </svg>
);

ArrowIcon.propTypes = {
  direction: PropTypes.oneOf(['prev', 'next']).isRequired,
};

/**
 * Numbered pagination row: prev arrow, page buttons with "..." gaps, next
 * arrow. `getPageNumbers` returns the pages to show, e.g. [1, '...', 5, 6].
 */
const PaginationControls = ({
  currentPage,
  totalPages,
  onPageChange,
  getPageNumbers,
}) => {
  const renderPage = (page, index) => {
    if (page === '...') {
      return <PageEllipsis key={`ellipsis-${index}`}>...</PageEllipsis>;
    }

    return (
      <ButtonV2
        variant="icon"
        key={page}
        active={page === currentPage}
        onClick={() => onPageChange(page)}
      >
        {page}
      </ButtonV2>
    );
  };

  return (
    <Pagination>
      <ButtonV2
        variant="icon"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        icon={<ArrowIcon direction="prev" />}
      />
      {getPageNumbers().map(renderPage)}
      <ButtonV2
        variant="icon"
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        icon={<ArrowIcon direction="next" />}
      />
    </Pagination>
  );
};

PaginationControls.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  getPageNumbers: PropTypes.func.isRequired,
};

export default PaginationControls;
